import { CommonModule } from "@angular/common";
import { Component, Input, forwardRef } from "@angular/core";
import {
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
  FormsModule,
} from "@angular/forms";
import { ColorPickerModule } from "ngx-color-picker";
import { DropdownModule } from "primeng/dropdown";
import { ColorSelectorComponent } from "./color-selector.component";
import * as _ from "lodash";
import { SimplifyColorsPipe } from "@app/pipe/simplify-colors.pipe";

@Component({
  imports: [
    CommonModule,
    FormsModule,
    DropdownModule,
    ColorPickerModule,
    ColorSelectorComponent,
    SimplifyColorsPipe,
  ],
  selector: "nis-border-selector",
  templateUrl: "./border-selector.component.html",
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BorderSelectorComponent),
      multi: true,
    },
  ],
})
export class BorderSelectorComponent implements ControlValueAccessor {
  borderWidth: number = undefined;
  borderOption: string = undefined;
  borderColor: string = undefined;

  borderOptions: { code: string }[] = [
    {
      code: "solid",
    },
    {
      code: "dotted",
    },
    {
      code: "dashed",
    },
    {
      code: "double",
    },
  ];

  @Input()
  brandColors: string[];

  initialized: boolean;

  private onChange: (value: any) => void;
  private onTouched: () => void;

  writeValue(value: any): void {
    if (value) {
      const values = value.split(" ");
      if (values.length === 3) {
        this.borderWidth = values[0].replace("px", "");
        this.borderOption = _.find(this.borderOptions, {
          code: values[1],
        })?.code;
        this.borderColor = values[2];
      }
    }
    this.initialized = true;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Handle the component's disabled state if necessary
  }

  updateBorder() {
    if (
      this.borderWidth === undefined ||
      this.borderOption === undefined ||
      this.borderColor === undefined
    ) {
      return;
    }
    this.onChange(
      `${this.borderWidth}px ${this.borderOption} ${this.borderColor}`
    );
    this.onTouched();
  }
}
